export default __webpack_public_path__ + "downloadf0c5ed.png";